//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, IMapInteractionConfig, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { MapLayerGroupType } from '../Shared/Models/MapConfigModels';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_legalmodals = '#placeholder-for-legalmodals',
    placeholder_for_legalmodals2 = '#placeholder-for-legalmodals2',

    troEditModal = '#troEditModal',
    troEditPathAffectedTable = '#troEditPathAffectedTable',
    troEditPathAffectedPrintBtn = '#troEditPathAffectedPrintBtn',
    troEditPathAffectedAddBtn = '#troEditPathAffectedAddBtn',
    troEditPathAffectedEditBtn = '#troEditPathAffectedEditBtn',
    troEditPathAffectedDeleteBtn = '#troEditPathAffectedDeleteBtn',

    troEdit_PathsAffectedAddModal = '#troEdit_PathsAffectedAddModal',
    troEdit_PathsAffectedAddCloseBtn = '#troEdit_PathsAffectedAddCloseBtn',
    troEdit_PathsAffectedAddForm = '#troEdit_PathsAffectedAddForm',
    troEdit_PathsAffectedAddForm_singlePathList = '#troEdit_PathsAffectedAddForm_singlePathList',
    troEdit_PathsAffectedAddCancelBtn = '#troEdit_PathsAffectedAddCancelBtn',
    troEdit_PathsAffectedAddSubmitBtn = '#troEdit_PathsAffectedAddSubmitBtn',

    addAffectedPathTROWizardPanel = '#addAffectedPathTROWizardPanel',
    addAffectedPathTROWizard_CancelBtn = '#addAffectedPathTROWizard_CancelBtn',
    addAffectedPathTROWizardCloseBtn = '#addAffectedPathTROWizardCloseBtn',
    addAffectedPathTROWizard_SaveBtn = '#addAffectedPathTROWizard_SaveBtn'
}

export class TRO_AffectedPaths {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private selectedRecordList: Array<string> = [];
    private selectedMapList: Array<string> = [];
    private newAddAffectedPathWizardState: { parentTROCode?: string, featureSelectedCAMSKeys?: Array<ICAMSKey> };
    private subscriptionMultipleFeaturesSelected;
    
    // List of buttions in the action toolbar
    private affectedPathsActionBtns = {
        viewprint: { btn: null, enable: false },
        add: { btn: null, enable: false },
        edit: { btn: null, enable: false },
        delete: { btn: null, enable: false }
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        const self = this;
        Utilities.GetControl(jqc.addAffectedPathTROWizard_SaveBtn).on('click', function () { self.addAffectedPathWizard_Save() });
        Utilities.GetControl(jqc.addAffectedPathTROWizard_CancelBtn).on('click', function () { self.addAffectedPathWizard_Cancel() });
        Utilities.GetControl(jqc.addAffectedPathTROWizardCloseBtn).on('click', function () { self.addAffectedPathWizard_Close() });
    }

    public initEvents = (data: ICAMSKey): void => {
        const self = this;
        
        // Initialize table btns
        self.affectedPathsActionBtns = {
            viewprint: { btn: $(jqc.troEditPathAffectedPrintBtn + ' button'), enable: false },
            add: { btn: $(jqc.troEditPathAffectedAddBtn + ' button'), enable: false },
            edit: { btn: $(jqc.troEditPathAffectedEditBtn + ' button'), enable: false },
            delete: { btn: $(jqc.troEditPathAffectedDeleteBtn + ' button'), enable: false }
        };
        self.affectedPathsActionBtns.viewprint.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.troEditPathAffectedTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].RouteCode, featureType: FeatureType.TRO };
            toastr.info("To be completed");
        });
        self.affectedPathsActionBtns.add.btn.on("click", function () {
            //self.openAddPanel(data);

            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventResetAllButtons(true))
            self.addAffectedPathWizard_Start(data.code);
        });
        self.affectedPathsActionBtns.edit.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.troEditPathAffectedTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].RouteCode, featureType: FeatureType.TRO };
            toastr.info("To be completed");
        });
        self.affectedPathsActionBtns.delete.btn.on("click", function () {
            self.deleteAffectedPaths(data);
        });

        // Initialize table
        var table: any = Utilities.GetControl(jqc.troEditPathAffectedTable)
        table.bootstrapTable();

        table.on('click-row.bs.table', function (e, row, $element) {
        });
        table.on('check.bs.table', function (e, row, $element) {
            self.checkAffectedPathsVisibleButtons();
        });
        table.on('check-all.bs.table', function (e, rowsAfter, rowsBefore) {
            self.checkAffectedPathsVisibleButtons();
        });
        table.on('uncheck.bs.table', function (e, row, $element) {
            self.checkAffectedPathsVisibleButtons();
        });
        table.on('uncheck-all.bs.table', function (e, rowsAfter, rowsBefore) {
            self.checkAffectedPathsVisibleButtons();
        });
        table.on('click-cell.bs.table', function (e, field, value, row, $element) {
            if (field == "AnnotationCount") {
                Utilities.GetModal(jqc.troEditModal, ModalAction.Hide);
                events.bus.publish(events.eventZoomToWKTandHighlight([[row.WKT], true, true, FeatureType.TRO]));
            }
        });

        // Get Paths affected data
        self.GetRoutesByTROCode(data);
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openAddPanel = (data: ICAMSKey): void => {
        const self = this;

        Utilities.BlockUI();
        var currentScrollPosition = Utilities.GetControl(jqc.troEditModal).scrollTop();
        Utilities.GetModal(jqc.troEditModal, ModalAction.Hide);
        Utilities.GetControl(jqc.placeholder_for_legalmodals2).load('/TRO/TRO_PathsAffectedAddView', {}, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.troEdit_PathsAffectedAddModal, ModalAction.Create);

            // Get selected map and record list data
            $(jqc.troEdit_PathsAffectedAddModal + ' [name="singlePathList_Input"]').on('keyup', function () { self.getPathsFromTypeAhead(); });
            self.GetDataFromRecordList();
            self.GetDataFromMapSelect();

            Utilities.GetControl(jqc.troEdit_PathsAffectedAddSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Get a list of all the paths selected
                let listOfPaths: Array<string> = [];
                if ($(jqc.troEdit_PathsAffectedAddModal + ' [name="singlePathList_Check"]').is(':checked').toString() == "true") {
                    listOfPaths.push($(jqc.troEdit_PathsAffectedAddModal + ' [name="singlePathList_Input"]').val().toString());
                }
                if ($(jqc.troEdit_PathsAffectedAddModal + ' [name="selectInList_Check"]').is(':checked').toString() == "true") {
                    listOfPaths = listOfPaths.concat(self.selectedRecordList);
                }
                if ($(jqc.troEdit_PathsAffectedAddModal + ' [name="selectOnMap_Check"]').is(':checked').toString() == "true") {
                    listOfPaths = listOfPaths.concat(self.selectedMapList);
                }

                if (listOfPaths.length == 0) {
                    toastr.info("Please select at least one item before adding");
                    return;
                }

                if (listOfPaths.length == 0) {
                    toastr.error("Please select at least one check box item!");
                    return;
                }

                Utilities.BlockUI();
                $.post('/TRO/AddRoutesToTRO', { troCode: data.code, listOfPaths: listOfPaths },
                    function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Added routes!')
                                self.GetRoutesByTROCode(data);
                                Utilities.GetModal(jqc.troEdit_PathsAffectedAddModal, ModalAction.Hide);
                                Utilities.GetModal(jqc.troEditModal, ModalAction.Show);
                                Utilities.GetControl(jqc.troEditModal).scrollTop(currentScrollPosition);
                            }
                            else {
                                toastr.error('Failed to add routes!')
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI();
                        }
                    }
                ).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            Utilities.GetControl(jqc.troEdit_PathsAffectedAddCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.troEdit_PathsAffectedAddModal, ModalAction.Hide);
                Utilities.GetModal(jqc.troEditModal, ModalAction.Show);
                Utilities.GetControl(jqc.troEditModal).scrollTop(currentScrollPosition);
            });

            Utilities.GetControl(jqc.troEdit_PathsAffectedAddCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.troEdit_PathsAffectedAddModal, ModalAction.Hide);
                Utilities.GetModal(jqc.troEditModal, ModalAction.Show);
                Utilities.GetControl(jqc.troEditModal).scrollTop(currentScrollPosition);
            });
        });
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetRoutesByTROCode = (data: ICAMSKey): void => {
        const self = this;

        let url = "/TRO/GetRoutesByTROCode";
        let query = { troCode: data.code };

        Utilities.BlockUI(Utilities.GetControl(jqc.troEditPathAffectedTable));
        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data = JSON.parse(result.data);
                        var table: any = Utilities.GetControl(jqc.troEditPathAffectedTable)
                        table.bootstrapTable('load', data);
                        self.checkAffectedPathsVisibleButtons();
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI(Utilities.GetControl(jqc.troEditPathAffectedTable));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetDataFromRecordList = (): void => {
        const self = this;
        events.bus.publish(events.eventGetRecordSelectRecords(function (data: Array<INode>) {
            self.selectedRecordList = [];
            data.forEach(d => { if (d.featureType == FeatureType.Route) self.selectedRecordList.push(d.href); });
            let el = $(jqc.troEdit_PathsAffectedAddModal + ' [name="selectInList"]');
            if (self.selectedRecordList.length == 0) {
                el.val("No records selected");
            }
            else {
                let s = ""; if (self.selectedRecordList.length > 0) s = "s";
                el.val(self.selectedRecordList.length + " record" + s + " selected");
            }
        }));
    }

    private GetDataFromMapSelect = (): void => {
        const self = this;
        events.bus.publish(events.eventGetMapSelectRecords(function (data: Array<INode>) {
            self.selectedMapList = [];
            data.forEach(d => { if (d.featureType == FeatureType.Route) self.selectedMapList.push(d.href); });
            let el = $(jqc.troEdit_PathsAffectedAddModal + ' [name="selectOnMap"]');
            if (self.selectedMapList.length == 0) {
                el.val("No records selected");
            }
            else {
                let s = ""; if (self.selectedMapList.length > 0) s = "s";
                el.val(self.selectedMapList.length + " record" + s + " selected");
            }
        }));
    }

    // ----------------------------------------------------------- //
    // CHECK BUTTONS
    private checkAffectedPathsVisibleButtons = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.troEditPathAffectedTable)
        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.affectedPathsActionBtns).forEach(k => {
            self.affectedPathsActionBtns[k].enable = false;
        });

        self.affectedPathsActionBtns.add.enable = true;
        // Then switch on the ones we want depending on the nde type
        if (rows && rows.length == 1) {
            self.affectedPathsActionBtns.viewprint.enable = true;
            self.affectedPathsActionBtns.edit.enable = true;
            self.affectedPathsActionBtns.delete.enable = true;
        }
        else if (rows && rows.length > 1) {
            self.affectedPathsActionBtns.delete.enable = true;
        }

        Object.keys(this.affectedPathsActionBtns).forEach(k => {
            if (self.affectedPathsActionBtns[k].enable == true) self.affectedPathsActionBtns[k].btn.prop("disabled", false);
            else self.affectedPathsActionBtns[k].btn.prop("disabled", true);
        });
    }

    // ----------------------------------------------------------- //
    // Add new affected path WIZARD
    public addAffectedPathWizard_Start = (troCode: string): void => {
        const self = this;

        Utilities.GetModal(jqc.troEditModal, ModalAction.Hide);
        Utilities.GetControl(jqc.addAffectedPathTROWizard_SaveBtn).hide();
        Utilities.GetControl(jqc.addAffectedPathTROWizardPanel).addClass('show');
 
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Route, true]));
        
        // Reset everything
        this.newAddAffectedPathWizardState = { parentTROCode: troCode, featureSelectedCAMSKeys: [] };
        if (self.subscriptionMultipleFeaturesSelected) self.subscriptionMultipleFeaturesSelected();

        // START: If a feature is provided then skip step 1, otherwise do step 1
        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: true, selectableLayers: [FeatureType.Route] };
        events.bus.publish(events.eventStartMultiSelection(interactionData));

        // STEP 1: Select Geom
        self.subscriptionMultipleFeaturesSelected = events.bus.subscribe(events.eventMultipleFeaturesSelected, m => {
            var data: Array <ICAMSKey> = [];
            m.payload.features.forEach(f => {
                var d: ICAMSKey = {};
                let props = f.getProperties();
                if (props.RouteCode != null) {
                    d.featureType = FeatureType.Route;
                    d.code = props.RouteCode;
                    data.push(d);
                }
         
            });

            self.newAddAffectedPathWizardState.featureSelectedCAMSKeys = data;
            $('#addAffectedPathTROWizard_SaveBtn').show();
        });

        // Zoom to existing rows
        var table: any = Utilities.GetControl(jqc.troEditPathAffectedTable);
        let wkts = table.bootstrapTable('getData').map(m => m.WKT);
        events.bus.publish(events.eventZoomToWKTandHighlight([wkts, true, true, FeatureType.TRO]));
    }

    private addAffectedPathWizard_Save = (): void => {
        const self = this;
        
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventClearSelectedFeatures());
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true))
        if (this.subscriptionMultipleFeaturesSelected) this.subscriptionMultipleFeaturesSelected();
        
        let routeCodes = this.newAddAffectedPathWizardState.featureSelectedCAMSKeys.map(d => d.code);

        Utilities.BlockUI();
        var currentScrollPosition = Utilities.GetControl(jqc.troEditModal).scrollTop();
        $.post('/TRO/AddRoutesToTRO', { troCode: this.newAddAffectedPathWizardState.parentTROCode, listOfPaths: routeCodes },
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        toastr.info('Added routes!')
                        self.GetRoutesByTROCode({ code: self.newAddAffectedPathWizardState.parentTROCode, featureType: FeatureType.TRO });
                        Utilities.GetModal(jqc.troEdit_PathsAffectedAddModal, ModalAction.Hide);
                    }
                    else {
                        toastr.error('Failed to add routes!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI();
                    Utilities.GetModal(jqc.troEditModal, ModalAction.Show);
                    Utilities.GetControl(jqc.troEditModal).scrollTop(currentScrollPosition);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });

    }

    private addAffectedPathWizard_Close = (): void => {
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventClearSelectedFeatures());
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true))
        if (this.subscriptionMultipleFeaturesSelected) this.subscriptionMultipleFeaturesSelected();
        Utilities.GetModal(jqc.troEditModal, ModalAction.Show);
    }

    private addAffectedPathWizard_Cancel = (): void => {
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventClearSelectedFeatures());
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true))
        if (this.subscriptionMultipleFeaturesSelected) this.subscriptionMultipleFeaturesSelected();
        Utilities.GetModal(jqc.troEditModal, ModalAction.Show);
    }

    // ----------------------------------------------------------- //
    // DELETE
    private deleteAffectedPaths = (data: ICAMSKey): void => {
        const self = this;

        var table: any = Utilities.GetControl(jqc.troEditPathAffectedTable)
        let rows: Array<any> = table.bootstrapTable('getSelections');
        let routeCodes = [];
        rows.forEach(r => {
            routeCodes.push(r.RouteCode);
        });

        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                deleteNow();
            }
            else {
            }
        }).catch(e => { });

        function deleteNow() {
            Utilities.BlockUI();
            $.post('/TRO/DeleteAffectedPaths', { troCode: data.code, routeCodes: routeCodes },
                function (result: IAPIResult) {
                    try {
                        if (result.success == true) {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            self.GetRoutesByTROCode(data);
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                    finally {
                        Utilities.UnBlockUI();
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // MISC
    private getPathsFromTypeAhead = (): void => {
        // Check if min length is entered
        let inputCtrl = $(jqc.troEdit_PathsAffectedAddModal + ' [name="singlePathList_Input"]');
        let listCtrl = Utilities.GetControl(jqc.troEdit_PathsAffectedAddForm_singlePathList);
        var searchStr = inputCtrl.val().toString();

        // Only get data for exactly 3 chars entered
        if (searchStr == null || searchStr.length < 3) {
            listCtrl.find('option').remove().end();
        }
        // If there is exactly 3 chars OR the list is close to the max length, then search again
        //else if (searchStr.length == 3 || listCtrl.children().length >5) {
        else if (searchStr.length >= 3) {
            // Disable control
            //inputCtrl.prop('disabled', true);
            //inputCtrl.prop('readonly', true);

            // Get List of paths
            let url = '/Route/GetRouteCodeList';
            let query = { searchStr: searchStr };
            $.post(url, query,
                function (result: IAPIResult) {
                    try {
                        if (result.success == true) {
                            // Delete existing paths
                            listCtrl.find('option').remove().end();

                            // Add paths to the list
                            result.data.forEach(i => {
                                listCtrl.append($("<option></option>").attr("value", i).text(i));
                            });
                        }
                        else {
                            toastr.error("Failed to get path data.")
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                    finally {
                        // Reneable ctrl
                        //inputCtrl.prop('disabled', false);
                        //inputCtrl.prop('readonly', false);
                        //inputCtrl.focus();
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }
}




